module.exports = __webpack_public_path__ + "static/media/20ECE16.4b326da0.jpg";